import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import pressure from "./components/pressure";
import pressureModulus from "./components/pressure-modulus";
import pressureModulusX0 from "./components/pressure-modulus-x0";
import dispersion from "./components/dispersion";

const principle: Slide = {
  description:
    "Consider a rectangular waveguide infinite-in-length along x-direction, 90 cm-wide and 50 cm-height. In such a waveguide, up to 15 modes can be guided along x at frequency lower than 1000 Hz, as it can be seen on the dispersion curves. Below the first cut-on frequency (~190 Hz), only the plane mode (0,0) is propagating. Below the second cut-on frequency (~340 Hz), two modes can propagate along the waveguide: (0,0) and (1,0) modes. And so on and so forth! Look how the pressure field (real part or modulus) is depending on the frequency for a given mode or for the sum of a selected number of propagating modes supposed to have the same amplitude. The origin of phase is assumed to be at x = 0 m.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [0.5, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Sum of modes",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "button",
                    options: {},
                    items: [
                      { name: "Pressure" },
                      { name: "Pressure modulus" },
                      { name: "Pressure field modulus at x = 0" },
                      { name: "Dispersion of propagating modes" },
                    ],
                  },
                ],
                controlsPosition: "top",
                extraContent: [[], [], [], []],
                components: [pressure, pressureModulus, pressureModulusX0, dispersion],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
